import { Flex, Icon, Text } from "@chakra-ui/react";
import type { APIListing } from "models/types/api-listing";
import BathIcon from "assets/icons/medium/bath.svg?react";
import BedIcon from "assets/icons/medium/bed.svg?react";
import BuildAreaIcon from "assets/icons/medium/build-area.svg?react";
import CarportIcon from "assets/icons/medium/car.svg?react";
import LandAreaIcon from "assets/icons/medium/land-area.svg?react";
import ListingAlternativeIcon from "assets/icons/medium/listing-alternative.svg?react";
import { PropertyCategories } from "types/property";

type PropertyAttributesProps = {
  propertyDetails?: APIListing["property"];
  propertyCategoryId?: PropertyCategories | null;
  advertisingPrice?: string;
};
export function PropertyAttributes({
  propertyDetails,
  propertyCategoryId,
  advertisingPrice,
}: PropertyAttributesProps) {
  const shouldDisplayAreaAttributes =
    propertyCategoryId === PropertyCategories.Commercial;
  const shouldDisplayBedAndBathAttributes =
    propertyCategoryId !== PropertyCategories.Commercial;

  return (
    <Flex
      wrap={{ base: "wrap", lg: "nowrap" }}
      w={"100%"}
      direction={"row"}
      align={"center"}
      columnGap={"24px"}
      rowGap={"6px"}
    >
      <Flex
        direction={"row"}
        wrap={"wrap"}
        align={"center"}
        gap={2}
        columnGap={3}
      >
        {shouldDisplayAreaAttributes ? (
          <>
            {propertyDetails?.build_area && (
              <Flex direction={"row"} align={"center"} gap={"4px"}>
                <Icon as={BuildAreaIcon} />
                <Text fontSize={"md"} fontWeight={600}>
                  {`${propertyDetails?.build_area}${propertyDetails?.build_area_unit?.label}`}
                </Text>
              </Flex>
            )}
            {propertyDetails?.land_area && (
              <Flex direction={"row"} align={"center"} gap={"4px"}>
                <Icon as={LandAreaIcon} />
                <Text fontSize={"md"} fontWeight={600}>
                  {`${propertyDetails?.land_area}${propertyDetails?.land_area_unit?.label}`}
                </Text>
              </Flex>
            )}
          </>
        ) : (
          <>
            {shouldDisplayBedAndBathAttributes && propertyDetails?.bedrooms && (
              <Flex direction={"row"} align={"center"} gap={"4px"}>
                <Icon as={BedIcon} />
                <Text fontSize={"md"} fontWeight={600}>
                  {propertyDetails?.bedrooms}
                </Text>
              </Flex>
            )}
            {shouldDisplayBedAndBathAttributes &&
              propertyDetails?.bathrooms && (
                <Flex direction={"row"} align={"center"} gap={"4px"}>
                  <Icon as={BathIcon} />

                  <Text fontSize={"md"} fontWeight={600}>
                    {propertyDetails?.bathrooms}
                  </Text>
                </Flex>
              )}
          </>
        )}
        {propertyDetails?.car_spaces && (
          <Flex direction={"row"} align={"center"} gap={"4px"}>
            <Icon as={CarportIcon} />

            <Text fontSize={"md"} fontWeight={600}>
              {propertyDetails?.car_spaces}
            </Text>
          </Flex>
        )}
        {advertisingPrice && (
          <Flex wrap={"nowrap"} direction={"row"} align={"center"} gap={"4px"}>
            <Icon as={ListingAlternativeIcon} />

            <Text
              fontSize={{ base: "md", md: "sm", lg: "md" }}
              fontWeight={600}
              whiteSpace={"nowrap"}
            >
              Advertised as {advertisingPrice}
            </Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
